define 'controller/ModalOverlayController', ['jquery', 'lib/kryptonite', 'bootstrap/modal'], ($) ->
  class ModalOverlayController

    constructor: (@$el) ->
      @_initializeOnLinkClickEvent()
      @_closeRightpanelLayerOnClick()
      @_showOnLoad()
      @_showAfterClick()
      @_showAfterKryptoniteReplace()

    _showModal: (target) ->
      $('.modal-dialog').removeClass('modal-hide-dialog')
      if target != 'undefined'
        $(target).modal('show')
        $(target).addClass(@$el.data('modal-type'))

    _showAfterKryptoniteReplace: ->
      if @$el.data("modal-show-on-replace")
        target = @$el.data('target')
        $targetElement = $(target)
        dataClass = @$el.data("class")
        dataModalType= @$el.data("modal-type")
        dataModalSize = @$el.data("modal-size")
        dataModalTitle= @$el.data("modal-title")
        @_setClassesOnModal($targetElement, dataClass, dataModalType, dataModalSize, dataModalTitle)
        @_showModal(target)

    _showAfterClick: ->
      self = @
      $("body").on "modal-overlay:show-after-click", (e) ->
        target = self.$el.data('target')
        self._showModal(target)

    _showOnLoad: ->
      self = @
      target = @$el.data('target')
      showOnLoad = @$el.data('show-on-load')
      $('.modal-dialog').removeClass('modal-hide-dialog')

      if true == showOnLoad
       if target != 'undefined'
          $(target).modal('show')

    _closeRightpanelLayerOnClick: ->
      closeLayer= this._closeRightpanelLayer
      $('.close-modal').off 'click'
      $('.close-modal').on 'click', (e) ->
        closeLayer(e.currentTarget)

      closeLayerButton = $('body')
      closeLayerButton.off 'click', '.right-panel-ATB-info__buttons--close-layer-button'
      closeLayerButton.on 'click', '.right-panel-ATB-info__buttons--close-layer-button', (e) ->
        closeLayer(e.currentTarget)

      transparentBackground = $('.modal-background')
      transparentBackground.off 'click'
      transparentBackground.on 'click', (e) ->
        closeLayer(e.currentTarget)

      # Make sure the classes are removed when the panel is closed
      self = @
      target = @$el.data('target')
      $(target).on "hide.bs.modal", (e) ->
        $(target).find('.modal-title').remove()
        $(target).removeClass("modal-right")
        $(target).find('.modal-dialog').removeClass("modal-header-shadow")
        $(target).find('.modal-title').removeClass("modal-title--full")
        $('body').removeClass('disableScrollOnShopPage')

    _closeRightpanelLayer: (element) ->
      $('body').removeClass('disableScrollOnShopPage')
      $parentElement = $(element).closest('#modalOverlayRight')
      $parentElement.modal('hide')
      setTimeout ->
        $parentElement.removeClass("modal-right")
      , 300

    _initializeOnLinkClickEvent: ->
      self = @
      
      $(@$el).on 'click',  (e) ->
        preventDefault = e.target.dataset.preventdefault
        if preventDefault == 'true'
          e.preventDefault()

        $('.close-modal').on 'click', ->
          e.preventDefault()
          $('.modal-dialog').addClass('modal-hide-dialog')

        self._onClickOpenEvent()
        self._onClickCloseEvent()

    _setClassesOnModal: (modalOverlayRight, dataClass, dataModalType, dataModalSize, dataModalTitle) ->
      # can not refactor setting attributedata, since it uses .data for @el and .attr for jq
      $('body').addClass('disableScrollOnShopPage')

      modalOverlayRight.find('.modal-dialog').removeClass('modal-hide-dialog')
      modalOverlayRight.find('.modal-dialog').addClass(dataClass)
      modalOverlayRight.find('.modal-dialog').data("class", dataClass)
      modalOverlayRight.find(".modal-dialog-size-js").removeClass "modal-size-M modal-size-L modal-size-XL"
      modalOverlayRight.addClass(dataModalType)
      modalOverlayRight.find('.modal-dialog').addClass(dataModalSize)

      if dataModalTitle && dataModalTitle != ""
        $modalTitle = $('<h3 class="modal-title panelModalRight--title"></h3>')
        $modalHeader = modalOverlayRight.find('[data-controller-element=modal-header]')
        $modalHeader.find(".modal-title").remove()
        $modalHeader.prepend($modalTitle.html(dataModalTitle))

    _onClickOpenEvent: ->
      dataTarget = @$el.data('target')

      if typeof @$el.data('class') != 'undefined'
        dataClass = @$el.data('class')
      else
        dataClass = ''

      if typeof @$el.data('modal-type') != 'undefined'
        dataModalType = @$el.data('modal-type')
      else
        dataModalType = ''

      if typeof @$el.data('modal-size') != 'undefined'
        dataModalSize = @$el.data('modal-size')
      else
        dataModalSize = 'modal-size-M'

      if typeof @$el.data('modal-title') != 'undefined'
        dataModalTitle = @$el.data('modal-title')
      else
        dataModalTitle = ''

      newfunction= this._setClassesOnModal # needed to use this._setClassesOnModal in next function ->
      targetElement= $(dataTarget)
      if($.isEmptyObject(targetElement))
        targetElement = $('#modalOverlayRight')

      targetElement.on 'shown.bs.modal', (e) ->
        $('.modal-background').addClass("modal-js-hide-background")
        base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/; # REGEX for base 64 encoding
        link = jQuery(e.relatedTarget) # load content from modal-link data-attr
        newfunction(targetElement, dataClass, dataModalType, dataModalSize, dataModalTitle)
        url = link.data('modal-link')
        preloadedContentSelector = link.data('modal-preloaded-content')
        showFullTitle = link.data('modal-full-title')

        if showFullTitle
          $(this).find('.modal-title').addClass("modal-title--full")

        if url
          if (base64regex.test(url)) # if the url is base 64 encoded decode it
            url = atob(url)
          $(this).find('.modal-body').load url, ->
        else if preloadedContentSelector && $(preloadedContentSelector).length > 0
          $(this).data("modal-preloaded-content", preloadedContentSelector)
          if link.data("modal-clone-content")
            $(this).find('.modal-body').html($(preloadedContentSelector).children().first().clone())
          else
            $(this).find('.modal-body').html($(preloadedContentSelector).children())

          $(this).trigger('modal:body-filled')

    _onClickCloseEvent: ->
      $('.modal-background').removeClass("modal-js-hide-background")
      if typeof @$el.data('modal-type') != 'undefined'
        dataModalType = @$el.data('modal-type')
      else
        dataModalType = ''

      dataTarget = @$el.data('target')
      
      # After global close event...
      $(dataTarget).off 'hidden.bs.modal'
      $(dataTarget).on 'hidden.bs.modal', (e) ->
        #... handle modal-dialog
        $modalDialog = $(this).find('.modal-dialog')
        dataClass = $modalDialog.data("class")
        $modalDialog.removeClass(dataClass)
        $modalDialog.removeAttr("data-class")

        #... reset content if necessary
        $modalBody = $(this).find('.modal-body')

        if $(this).data("modal-preloaded-content") && $(this).data("modal-preloaded-content") != ''
          $preloadedContent = $($(this).data('modal-preloaded-content'))
          resetContent = $preloadedContent.data("modal-reset-content")
          if resetContent && $preloadedContent.length > 0
            $preloadedContent.html($modalBody.children())
          $(this).data('modal-preloaded-content', '')

        #... remove content
        $(this).removeClass(dataModalType)
        $modalBody.empty()

        # ...discard listener on global events
        $(dataTarget).off 'shown.bs.modal'
        $(dataTarget).off 'hidden.bs.modal'

    destroy: ->
      @$el.off()
